import React from 'react';
import { SalesPerformance } from './SalesPerformance';
import { SalesLeaderboard } from './SalesLeaderboard';
import { ScheduleSection } from './ScheduleSection';
import { QuickActions } from './QuickActions';
import { RecentActivity } from './RecentActivity';
export const Dashboard = () => {
  return <div className="space-y-6" data-id="element-2257">
      <div className="flex justify-between items-center" data-id="element-2258">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-2259">Dashboard</h1>
        <div className="flex space-x-2" data-id="element-2260">
          <select className="border border-gray-300 rounded-md text-sm px-3 py-1.5" data-id="element-2261">
            <option data-id="element-2262">This Week</option>
            <option data-id="element-2263">This Month</option>
            <option data-id="element-2264">This Quarter</option>
            <option data-id="element-2265">This Year</option>
          </select>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-6" data-id="element-2266">
        {/* Left Column */}
        <div className="col-span-2 space-y-6" data-id="element-2267">
          <SalesPerformance data-id="element-2268" />
          <SalesLeaderboard data-id="element-2269" />
        </div>
        {/* Right Column */}
        <div className="space-y-6" data-id="element-2270">
          <QuickActions data-id="element-2271" />
          <ScheduleSection data-id="element-2272" />
          <RecentActivity data-id="element-2273" />
        </div>
      </div>
    </div>;
};